export default "__VITE_ASSET__375eae30__"